import React, { useState, useCallback, useEffect, HTMLBRElement } from "react";
import _uniqueId from "lodash/uniqueId";
import "../../Assets/Css/Components/FieldHootsuiteUpload.css";
import profile from "../../Assets/Images/avatar-sc.png";
import { Button } from "react-bootstrap";
import Image from "../Image/image";

export default function FieldHootsuiteUpload({
  previewUrl,
  style,
  information,
  onChange,
  required = false,
  disabled = false,
  readOnly = false,
  showButtonUpload = false,
  classNames = "",
  error,
  maxSize = 2048000000,
  radius = "50%",
  imgWrapClass,
}) {
  useEffect(() => {
    setImagePreviewUrl(previewUrl);
  }, [previewUrl]);

  const [id] = useState(_uniqueId("field_"));
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(false);
  const [localError, setLocalError] = useState([]);

  const handlePhotoUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (file) {
      const errors = [];
      if (file.size > maxSize) {
        errors.push({ message: "Max file size is " + maxSize });
        setLocalError(errors);
      } else if (file.type.split("/")[0] != "image") {
        errors.push({ message: "You must select an image file." });
        setLocalError(errors);
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          onChange(file, reader.result);
          setUploadedImage(true);
          setImagePreviewUrl(reader.result);
          setLocalError([]);
        };

        reader.onerror = (e) => {
          alert("Erro");
          errors.push(e.message);
          setLocalError(errors);
        };

        reader.readAsDataURL(file);
      }
    }
  };

  return (
    <>
      <div className={"form-group " + classNames} style={{ textAlign: "center", ...style }}>
        <label htmlFor={id} className="custom-file-upload">
          <div className={`img-wrap img-upload ${imgWrapClass} full-image`} style={{ pointerEvents: readOnly ? 'none' : 'auto' }} >
            <Image className="main-chat-content" src={imagePreviewUrl} radius={20} />
          </div>
          <input id={id} type="file" className="fieldUpload" onChange={handlePhotoUpload} required={required} disabled={disabled} readOnly={readOnly} accept="image/*" />
        </label>

        {error || localError?.length > 0 ? (
          <div className="invalid-feedback" style={{ display: "block" }}>
            <ul>
              {error ? <li>{error}</li> : null}
              {localError?.length > 0 ? localError.map((x, index) => <li key={index}>{x.message}</li>) : null}
            </ul>
          </div>
        ) : null}
      </div>
    </>
  );
}
